module.exports = __webpack_public_path__ + "img/blob2.f48dd649.svg";